import { render } from "./ListeTaxe.vue?vue&type=template&id=6b6ca569&ts=true"
import script from "./ListeTaxe.vue?vue&type=script&lang=ts"
export * from "./ListeTaxe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__